import styled from "@emotion/styled";

export const Section = styled.section<{ background?: string }>`
  display: flex;
  justify-content: center;
  background: ${({ background, theme }) => background ?? theme.palette.custom.white};
`;
